function isElementInViewport(el, partially = false, onlyVertical = false) {
  const rect = el.getBoundingClientRect();
  const part = (partially) ? rect.height * partially : 0;

  if(!onlyVertical) {
    return (
      rect.top + part >= 0 &&
      rect.left >= 0 &&
      rect.bottom - part <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  else {
    return (
      rect.top + part >= 0 &&
      rect.bottom - part <= (window.innerHeight || document.documentElement.clientHeight)
    )
  }
}
